import { gql } from '@apollo/client';
import WDT_STUDENT_SETTINGS_FRAGMENT from '../../fragments/wdt-student-settings';

const GET_WDT_STUDENT_SETTINGS = gql`
  query wdtStudentSettings($where: PliStudentSettingsWhereInput!) {
    wdtStudentSettings(where: $where) {
      ...BaseWdtStudentSettings
    }
  }
  ${WDT_STUDENT_SETTINGS_FRAGMENT}
`;

export default GET_WDT_STUDENT_SETTINGS;
